import colors from '../config/colors.json'
import { Scatter } from 'react-chartjs-2'
import { useRef } from 'react'
import { sweepClipPlugin, useAnnotationEntrance, useChartEntrance } from '../helpers/chartAnimation'

// `animate` is only true after the dashboard fired the animate event, the chart is remounted with a
// new key each time so the entrance runs from the start again.
const EconomyChart = ({ match, annotations, height, summary, animate }) => {
	const chartRef = useRef(null)
	const shownAnnotations = useAnnotationEntrance(annotations, animate)
	useChartEntrance(chartRef, animate)

	return (
		<div className="charts__economy">
			<h1 className="charts__economy__title charts__title ">Economy Count</h1>
			<Scatter
				className=""
				ref={chartRef}
				plugins={[sweepClipPlugin]}
				datasetIdKey="id"
				height={height}
				style={{ maxHeight: height }}
				options={{
					maintainAspectRatio: false,
					aspectRatio: 1,
					// The entrance is drawn by sweepClipPlugin, chart.js itself never animates
					animation: false,
					parsing: false,
					normalized: true,
					legend: {
						display: false,
					},
					title: {
						display: false,
					},
					scales: {
						x: {
							min: 20,
							ticks: {
								stepSize: 60,
								callback: (v) => (v >= 30 ? (v / 60).toString() + ' min' : ''),
								color: 'white',
							},
							grid: {
								color: 'rgba(255,255,255,.3)',
							},
						},
						y: {
							beginAtZero: true,
							ticks: {
								color: 'white',
								font: { size: 20 },
							},
							grid: {
								color: 'rgba(255,255,255,.3)',
							},
							afterFit: (axis) => {
								axis.width = Math.max(axis.width, 60)
							},
						},
					},
					plugins: {
						legend: {
							display: false,
						},
						annotation: {
							annotations: shownAnnotations,
						},
					},
				}}
				data={{
					datasets: [
						{
							id: 'leftEconomy',
							label: '',
							type: 'line',
							data: summary?.players[0].timeline.map((v) => ({
								x: v.time,
								y: v.population_economy,
							})),
							borderColor: colors[match.leftPlayer.color]?.mainColor,
							borderWidth: 4,
							pointRadius: 0,
						},

						{
							id: 'leftEconomyTotal',
							label: '',
							type: 'line',
							data: summary?.players[0].timeline.map((v) => ({
								x: v.time,
								y: v.population_economy_total,
							})),
							borderColor: colors[match.leftPlayer.color]?.secondaryColor,
							borderWidth: 4,
							pointRadius: 0,
							borderDash: [6, 6],
						},
						{
							id: 'rightEconomy',
							label: '',
							type: 'line',
							data: summary?.players[1].timeline.map((v) => ({
								x: v.time,
								y: v.population_economy,
							})),
							borderColor: colors[match.rightPlayer.color]?.mainColor,
							borderWidth: 4,
							pointRadius: 0,
						},
						{
							id: 'rightEconomyTotal',
							label: '',
							type: 'line',
							data: summary?.players[1].timeline.map((v) => ({
								x: v.time,
								y: v.population_economy_total,
							})),
							borderColor: colors[match.rightPlayer.color]?.secondaryColor,
							borderWidth: 4,
							pointRadius: 0,
							borderDash: [6, 6],
						},
					],
				}}
			/>
		</div>
	)
}

export { EconomyChart }
